
import {autoUpload} from '../../network/index'

export default function fileDellow (confing){
    const lang_file = sessionStorage.getItem("lang_file");
      const token = sessionStorage.getItem("token");
      let formData = new FormData();
      formData.append("image", confing.file);
      formData.append("appid", token);
      formData.append("lang_file", lang_file);
    return new Promise(async(resolve,reject)=>{
        const {code,data,msg} = await autoUpload(formData)
        if(code){
            resolve(data)
        }
    })
}